/**
 * Tote cross-sell — Cart Drawer
 *
 * Với mỗi design Leather Boots trong cart, gợi ý đúng Tote Bag cùng design.
 * Dedupe theo design: 2 đôi cùng design vẫn chỉ 1 offer.
 *
 * Đồng bộ với cart: theme Broadcast replace innerHTML của [data-items-holder]
 * mỗi lần cart đổi -> MutationObserver bắt được mọi thay đổi mà không phải
 * patch theme.js. Sau khi add thì bắn 'theme:cart:refresh' (event native của theme).
 */
(function () {
  'use strict';

  var SEL = {
    root: '[data-tote-cross-sell]',
    list: '[data-tote-cross-sell-list]',
    map: '[data-tote-cross-sell-map]',
    itemsHolder: '[data-items-holder]',
  };

  var root = document.querySelector(SEL.root);
  var mapNode = document.querySelector(SEL.map);
  if (!root || !mapNode) return;

  var TOTES;
  try {
    TOTES = JSON.parse(mapNode.textContent);
  } catch (e) {
    return; // map hỏng -> im lặng, không phá cart
  }

  var byBoot = {};
  TOTES.forEach(function (t) {
    byBoot[t.bootHandle] = t;
  });

  var BOOTS_TYPE = root.dataset.bootsType || 'Leather Boots';
  var TOTES_TYPE = root.dataset.totesType || 'Tote Bag';
  var listEl = root.querySelector(SEL.list);
  var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var inFlight = false;

  /** Tote nào nên hiện: boots có trong cart, chưa có tote tương ứng, mỗi design 1 lần. */
  function pickOffers(cart) {
    var totesInCart = {};
    var offers = [];
    var seen = {};

    cart.items.forEach(function (item) {
      if (item.product_type === TOTES_TYPE) totesInCart[item.handle] = true;
    });

    cart.items.forEach(function (item) {
      if (item.product_type !== BOOTS_TYPE) return;

      var tote = byBoot[item.handle];
      if (!tote) return;
      if (seen[tote.bootHandle]) return; // cùng design -> chỉ 1 offer
      if (totesInCart[tote.toteHandle]) return; // đã mua rồi -> thôi

      seen[tote.bootHandle] = true;
      offers.push(tote);
    });

    return offers;
  }

  function offerMarkup(tote) {
    var priceHtml = tote.hasDiscount
      ? '<span class="tote-xsell__now">' + tote.price + '</span>' +
        '<span class="tote-xsell__was">' + tote.comparePrice + '</span>' +
        '<span class="tote-xsell__save">save ' + tote.saveAmount + '</span>'
      : '<span class="tote-xsell__now">' + tote.price + '</span>';

    var question = tote.hasDiscount
      ? 'ADD the <b>' + tote.designName + '</b> tote with ' + tote.savePct + '% off?'
      : 'ADD the <b>' + tote.designName + '</b> tote?';

    var image = tote.image
      ? '<img src="' + tote.image + '" alt="' + tote.designName + ' Tote Bag" width="60" height="60" loading="lazy">'
      : '';

    return (
      '<div class="tote-xsell__item" data-tote-offer="' + tote.variantId + '">' +
      '<a class="tote-xsell__thumb" href="' + tote.url + '" tabindex="-1" aria-hidden="true">' + image + '</a>' +
      '<div class="tote-xsell__text">' +
      '<p class="tote-xsell__q">' + question + '</p>' +
      '<div class="tote-xsell__price">' + priceHtml + '</div>' +
      '</div>' +
      '<button type="button" class="tote-xsell__add" data-tote-add="' + tote.variantId + '">Add</button>' +
      '</div>'
    );
  }

  function render(offers) {
    if (!offers.length) {
      root.hidden = true;
      listEl.innerHTML = '';
      return;
    }
    listEl.innerHTML = offers.map(offerMarkup).join('');
    root.hidden = false;
    currentOffers = offers;
    watchVisible();
  }

  /* ---- Tracking ----------------------------------------------------------
   * Add: line item property '_source' -> chảy vào order line item, prefix '_'
   *      nên theme không render ra cho khách (cart-line-items.liquid bỏ qua).
   * Impression: cart attribute 'tote_xsell_shown' -> chảy vào order note
   *      attributes, cho biết đơn đó ĐÃ THẤY offer nào -> có mẫu số tính
   *      take-rate thật thay vì chia cho tổng đơn.
   *
   * Block nằm sẵn trong DOM ngay từ lúc load trang, drawer đóng thì nó bị đẩy
   * ra ngoài viewport. Nếu ghi lúc render thì "shown" tính cả người chưa mở
   * cart -> mẫu số phồng, take-rate bị hiểu thấp. Nên phải chờ
   * IntersectionObserver xác nhận nó thật sự lọt vào viewport.
   * -------------------------------------------------------------------- */

  var SHOWN_KEY = 'toteXsellShown';
  var shownMem = null;
  var currentOffers = [];
  var visObserver = null;
  var isVisible = false;

  function watchVisible() {
    if (!window.IntersectionObserver) {
      markShown(currentOffers); // trình duyệt cũ -> chấp nhận đếm rộng hơn
      return;
    }

    if (!visObserver) {
      visObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          isVisible = entry.isIntersecting;
          if (isVisible) markShown(currentOffers);
        });
      }, { threshold: 0.5 });
      visObserver.observe(root);
      return;
    }

    // Đang mở sẵn mà offers vừa đổi -> observer không bắn lại, phải tự ghi.
    if (isVisible) markShown(currentOffers);
  }

  function readShown() {
    if (shownMem) return shownMem;
    var raw = '';
    try {
      raw = sessionStorage.getItem(SHOWN_KEY) || '';
    } catch (e) {
      raw = '';
    }
    shownMem = raw ? raw.split(',') : [];
    return shownMem;
  }

  function markShown(offers) {
    var known = readShown();
    var merged = known.slice();

    offers.forEach(function (o) {
      if (merged.indexOf(o.toteHandle) === -1) merged.push(o.toteHandle);
    });
    if (merged.length === known.length) return; // không có tote mới -> khỏi gọi API

    shownMem = merged;
    try {
      sessionStorage.setItem(SHOWN_KEY, merged.join(','));
    } catch (e) {
      /* private mode -> giữ trong bộ nhớ thôi */
    }

    // Chỉ set attributes -> Shopify merge, không đụng note/items sẵn có.
    fetch(rootUrl + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { tote_xsell_shown: merged.join(',') } }),
    }).catch(function () {
      /* tracking hỏng không được phá cart */
    });
  }

  function refresh() {
    return fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        render(pickOffers(cart));
      })
      .catch(function () {
        root.hidden = true;
      });
  }

  function addTote(variantId, button) {
    if (inFlight) return;
    inFlight = true;
    button.classList.add('is-loading');
    button.disabled = true;

    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1,
            properties: { _source: 'cart-tote-xsell' },
          },
        ],
      }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        // Event native của Broadcast -> cart-drawer.getCart() re-render line items + total
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        return refresh();
      })
      .catch(function () {
        button.classList.remove('is-loading');
        button.disabled = false;
        button.textContent = 'Try again';
      })
      .finally(function () {
        inFlight = false;
      });
  }

  listEl.addEventListener('click', function (e) {
    var button = e.target.closest('[data-tote-add]');
    if (!button) return;
    e.preventDefault();
    addTote(button.dataset.toteAdd, button);
  });

  // Theme replace innerHTML của items holder mỗi lần cart đổi -> bám vào đó.
  var itemsHolder = document.querySelector(SEL.itemsHolder);
  if (itemsHolder) {
    var pending;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(refresh, 120);
    }).observe(itemsHolder, { childList: true, subtree: true });
  }

  refresh();
})();
